import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import QuestionThree from "./questionThree";
import {
  incrementSteps,
  resetExperienceStepValues,
} from "../../../../Infrastructure/States/educatorStepsSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  ContinueButton,
  Footer,
} from "../../styles";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import QuestionOne from "./questionOne";
import QuestionTwo from "./questionTwo";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../../Infrastructure/config";
import { ShowErrorToast } from "../../../Common/Toast/toast";
import { useNavigate } from "react-router-dom";
import { DarkBgLoader, Loader } from "../../../Common/Loader/loader";
import { EduAccFlowHeader } from "../../../Common/EduAccFlowHeader/eduAccFlowHeader";
import ERROR_CONSTANTS from "../../../../Infrastructure/Constants/errorConstants";
import useAuthentication from "../../../../Infrastructure/States/onAuthStateChange";
import paths from "../../../../Infrastructure/Router/paths";
import { USER_LOGS_CLIENT } from "../../../../Infrastructure/Constants/logsConstant";
import { safeClientLogEvent } from "../../../../Infrastructure/Utilities/safeClientLogEvent";
import { experienceStepSX } from "./styles";

export const ExperienceStep = ({ lastPageRoute, urlInfoObj }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {userId} = useAuthentication()
  const { title, subtitle, fromJob } = urlInfoObj
  const [isLoading, setIsLoading] = useState(false);
  const ip = useSelector((state) => state.ip.address)
  const page = useSelector((state)=> state.route.currentRoute)
  const [exitLoading, setExitLoading] = useState(false);
  const steps = useSelector((state) => state.educatorSteps.steps);
  const experienceStep = useSelector(
    (state) => state.educatorSteps.experienceStep
  );
  
  const handleInc = async () => {
    if (steps >= 1 && steps < 4) {
      try {
        setIsLoading(true)
        const updateexperiences = httpsCallable(
          functions,
          "updateexperiencestep"
        );
        await updateexperiences({...experienceStep, ip, page});
        dispatch(incrementSteps())
      } catch (error) {
        ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
        await safeClientLogEvent({
          ...USER_LOGS_CLIENT.EXPERIENCE_STEP_UPDATE_FAILED,
          uid: userId || null,
          source: "experienceStep.jsx",
          emailInfo: null,
          metadata: { experienceStep },
          error: error?.message || null
        });
      } finally {
        setIsLoading(false)
      }
    }
  };
  const handleExit = async () => {
    try {
      setExitLoading(true)
      const updateexperiences = httpsCallable(
        functions,
        "updateexperiencestep"
      );
      await updateexperiences({...experienceStep, onboarding_step:2, ip, page});
      dispatch(resetExperienceStepValues());
      navigate(lastPageRoute || paths.home.path)
    } catch (err) {
      navigate(lastPageRoute || paths.home.path)
      ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
      await safeClientLogEvent({
          ...USER_LOGS_CLIENT.EXPERIENCE_STEP_UPDATE_FAILED,
          uid: userId || null,
          source: "experienceStep.jsx",
          emailInfo: null,
          metadata: { experienceStep },
          error: err?.message || null
        });
    } finally {
      setExitLoading(false)
    }
  };
  return (
    <>
      <EduAccFlowHeader handleExit={handleExit} steps={steps} />
      {exitLoading ? <DarkBgLoader height={"100vh"} /> : null}
      {
        isLoading ? <Loader height={'100vh'} /> :
          <Box sx={experienceStepSX.containerBox}>
            <Grid container sx={experienceStepSX.gridContainer}>
              <Grid lg={4} md={6} sm={10} xs={12}>
                <Box sx={experienceStepSX.gridItemBox}>
                  <Box sx={experienceStepSX.innerBox}>
                    <QuestionTwo />
                  </Box>
                </Box>
              </Grid>
              <Grid lg={4} md={6} sm={10} xs={12}>
                <Box sx={experienceStepSX.gridItemBox}>
                  <Box sx={experienceStepSX.innerBox}>
                    <QuestionOne />
                  </Box>
                </Box>
              </Grid>
              <Grid lg={4} md={6} sm={10} xs={12}>
                <Box sx={experienceStepSX.gridItemBox}>
                  <Box sx={experienceStepSX.innerBox}>
                    <QuestionThree />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
      }
      <Footer>
  {/* Title ABOVE buttons on small screens */}
  {fromJob && (
    <Typography sx={experienceStepSX.footerTitleMobile}>
      {title} - {subtitle}
    </Typography>
  )}

  <Grid container justifyContent="space-between" alignItems="center" p={2}>

    {/* Left Spacer */}
    <Grid xs={1}/>

    {/* Title CENTERED between buttons on large screens */}
    {fromJob && (
      <Grid xs={12} md="auto" sx={experienceStepSX.footerTitleDesktop}>
        <Typography>
          {title} - {subtitle}
        </Typography>
      </Grid>
    )}
    <Grid sx={experienceStepSX.continueButton}>
      <ContinueButton
        disabled={
          !(
            (experienceStep.inPerson ||
              experienceStep.liveOnline ||
              experienceStep.recordedOnline ||
              experienceStep.mediumOther) &&
            (experienceStep.professor ||
              experienceStep.teacher ||
              experienceStep.independent ||
              experienceStep.experienceOther ||
              experienceStep.tutor) &&
            experienceStep.years.trim() !== ""
          ) || isLoading
        }
        variant="contained"
        onClick={handleInc}
      >
        Continue
      </ContinueButton>
    </Grid>
  </Grid>
</Footer>
    </>
  );
};
